import userQueries from '@apis/queries/userQueries';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useCookies } from 'react-cookie';

function useUser() {
    const [cookies] = useCookies(['refreshToken']);
    const { refreshToken } = cookies;
    const enabled = !!refreshToken;
    const { data: user, status } = useQuery({
        ...userQueries.profile(),
        enabled,
        retry: 2,
    });
    const queryClient = useQueryClient();
    const getUserProfile = useCallback(() => {
        queryClient.invalidateQueries({ queryKey: userQueries.profile._def });
    }, [refreshToken]);
    const isLoading = status === 'pending' && enabled;
    return { user, getUserProfile, isLoading };
}

export default useUser;
